import {
  SCA_SYNC_RECIPIENT,
  SCA_SYNC_RECIPIENT_SUCCESS,
  SCA_SYNC_RECIPIENT_FAILURE,
  SCA_SYNC_RECIPIENT_RESET,
  SCA_RECIPIENT_READY,
} from '../constants';

const initial = {
  phase: 'idle', // 'idle' | 'polling' | 'ready' | 'error'
  rid: null,
  remote_status: null,
  sca_bank_action_url: null,
  db_bank_account_added_at: null,
  error: null,
};

export default function scaRecipientSyncReducer(state = initial, action) {
  switch (action.type) {
    case SCA_SYNC_RECIPIENT:
      return {
        ...state,
        phase: 'polling',
        rid: action.payload.rid,
        error: null,
      };

    case SCA_SYNC_RECIPIENT_SUCCESS: {
      const remote_status = action.payload.remote_status ?? null;
      const terminal = (action.payload.terminal != null)
        ? !!action.payload.terminal
        : ['ACTIVE', 'CANCELED', 'DEACTIVATED'].includes(remote_status);

      return {
        ...state,
        remote_status,
        sca_bank_action_url: action.payload.sca_bank_action_url ?? null,
        db_bank_account_added_at: action.payload.db_bank_account_added_at ?? null,
        phase: (terminal || action.payload.ready === true) ? 'ready' : 'polling',
      };
    }

    case SCA_RECIPIENT_READY:
      return { ...state, phase: 'ready' };

    case SCA_SYNC_RECIPIENT_FAILURE:
      return { ...state, phase: 'error', error: action.error || 'unknown' };

    case SCA_SYNC_RECIPIENT_RESET:
      return initial;

    default:
      return state;
  }
}
